import { IClientValidator } from "./IClientValidator.js";

    /// Attaches to hidden input elements that are marked up as turnstile validators.
    export class Turnstile implements IClientValidator {
        public validate(value: string, element: HTMLInputElement, params: any): boolean {
            let containerId = element.dataset["valContainerId"];

            if (containerId) {
                let containerElement = document.getElementById(containerId);

                if (!containerElement) {
                    return true;
                }

                let tokenElements = document.getElementsByName("cf-turnstile-response");
                if (tokenElements.length !== 1) {
                    let validatorSpanElement = document.getElementById("ValidatorTurnstile");
                    validatorSpanElement.innerHTML = "The security script has failed to load, please check your browser is not blocking scripts from Cloudflare and refresh this page.";
                    return false;
                }

                let tokenElement = tokenElements[0] as HTMLInputElement;
                if (!tokenElement.value) {
                    return false;
                }
                return true;
            }
            return true;
        }
    }

window.validators = window.validators || {};
window.validators.turnstile = new Turnstile();
